import { render, staticRenderFns } from "./customer_contact_select.vue?vue&type=template&id=36b9024c&"
import script from "./customer_contact_select.vue?vue&type=script&lang=js&"
export * from "./customer_contact_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports